

























































import Skrining from "@/services/new/Skrining";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { storePerawat } from "@/store/modules/perawat";
import { userModule } from "@/store/modules/user";
import ErrorAlert from "@/utility/ErrorAlert";
import { Component, Vue, Watch } from "vue-property-decorator";
import PerawatAutoComplete from "./PerawatAutoComplete.vue";
import TimeStamp from "./TimeStamp.vue";
import UserDropDownField from "@/components/UserDropDownField.vue";
import moment from "moment";

@Component({
  components: {
    PerawatAutoComplete,
    TimeStamp,
    UserDropDownField
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class SkriningBatukTabPage extends Vue {
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  batuk = null;
  petugas = null;
  time = moment().format("HH:mm:ss");
  today = moment().format("YYYY-MM-DD");
  maxDate = new Date().toISOString().substr(0, 10);
  saving = false;
  waktu_periksa = this.today + " " + this.time;
  id = null;

  mounted() {
    const data = this.skriningData;
    if (data) {
      this.id = data.id;
      this.batuk = data.content.value;
      this.petugas = this.listPetugas.find(item => item.id === data.user_id);
      this.waktu_periksa = data.examined_at;

      console.log("petugas", this.petugas);
    } else {
      this.petugas = this.listPetugas.find(item => item.id === this.user.id);
    }
  }

  setTime(time: string) {
    this.waktu_periksa = time;
  }

  // setPetugas(petugas: any) {
  //   console.log("petugas", petugas);
  //   this.petugas = petugas;
  // }

  get skriningData() {
    return storePasien.identitasPasien?.skrining?.find(
      item => item.category === "batuk"
    );
  }

  get sendData() {
    return {
      content: {
        value: this.batuk
      },
      user_id: this.petugas?.id,
      examined_at: this.waktu_periksa,
      pasien_rm: this.pasien.rm,
      register_id: this.pasien.register["no"],
      unit_id: this.user.unit_id
    };
  }

  get pasien() {
    return storePasien.identitasPasien;
  }

  get user() {
    return userModule.user;
  }

  get listPetugas() {
    return storePerawat.listKaryawan;
  }

  @Watch("skriningData", { deep: true })
  skriningDataChanged(val) {
    console.log("skriningDataChanged");
    if (val) {
      console.log("set data", val);
      this.id = val.id;
      this.batuk = val.content.value;
      this.petugas = this.listPetugas.find(item => item.id === val.user_id);
      this.waktu_periksa = val.examined_at;
    }
  }

  async save() {
    if (!this.saving) {
      this.saving = true;

      try {
        const save = this.id
          ? await Skrining.updateSkriningBatuk(this.id, this.sendData)
          : await Skrining.createSkriningBatuk(this.sendData);

        if (save) {
          if (this.id) {
            appModule.NoticeDelay("Berhasil Ubah Skrining Batuk");
          } else {
            appModule.NoticeDelay("Berhasil Simpan Skrining Batuk");
          }
        } else {
          ErrorAlert.showErrorAlert(save.message);
        }
      } finally {
        this.saving = false;

        storePasien.getSkriningByReg();
      }
    }
  }
}
